import { css } from "styled-components";
export const datePlaceholderMixin = css `
  &:lang(en-us) {
    content: "MM/DD/YYYY";
  }

  &:lang(es-es) {
    content: "dd/mm/aaaa";
  }

  &:lang(de-de) {
    content: "TT.mm.jjjj";
  }

  &:lang(fr-fr) {
    content: "jj/mm/aaaa";
  }

  &:lang(pr-br) {
    content: "dd/mm/aaaa";
  }

  &:lang(ja-jp) {
    content: "yyyy/mm/dd";
  }

  &:lang(pl-pl) {
    content: "dd/mm/yyyy";
  }
`;
//# sourceMappingURL=mixins.js.map